import { render, staticRenderFns } from "./RemoveAdvertModal.vue?vue&type=template&id=73009e2c&scoped=true&"
import script from "./RemoveAdvertModal.vue?vue&type=script&lang=js&"
export * from "./RemoveAdvertModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAdvertModal.vue?vue&type=style&index=0&id=73009e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73009e2c",
  null
  
)

export default component.exports